module.exports = __webpack_public_path__ + "img/logo-icon.cc3c2d28.png";